<template>
<div>
    <NavBar/>
    <div v-if="!isMobile()">
        <img  class="breedfuse" src="../assets/pages/breedfuse.png" alt="" usemap="#image-mapRewards">
        
        <map name="image-mapRewards">
            <area class="areaClick" target="" @click="openBabyModal()" alt="genesis" title="genesis" coords="77,334,481,453" shape="rect">
            <area class="areaClick" target="" @click="openFuseModal()" alt="fusion" title="fusion"  coords="1461,331,1865,451" shape="rect">
        </map>
    </div>

            <b-modal size="xl" hide-footer title="BABY BREEDING" ref="modal-1" >
            <div v-if="!isApproved">
                <button v-if="!loadingTransaction && !isApproved" class="button-35" @click="babyApprove()">Approve Breeding!</button>
                <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
            </div>

            <br><br>
            <div v-if="isApproved">
                <h4 class="centerTxt" v-if="nftsById.length > 0">SELECT DUCKS FOR BREEDING</h4>
                    <br><br>
                    <div v-for="(id) in nftsById" :key="id">
                        <a @click="addNft(id)" v-if="id <= 1000" class="cardClick"><b-card
                            :title="'Genesis #' + id"
                            tag="duck"
                            class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs"
                            :id="'duck' + id"
                        >
                        <img  class="imageOfDuck" :src="genesisIpfs + id + '.gif'" alt="">
                        </b-card></a>
                    </div>
                    <br><br><br><br><br><br><br><br><br><br>
                    <br><br><br><br><br><br><br><br><br><br>
                    <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                    <input v-if="selectedToBreed.length > 0 && !loadingTransaction" type="number" id="howMany" min="1" value="1" max="30" placeholder="How Many Babies?">
                    <button v-if="selectedToBreed.length > 0 && !loadingTransaction" class="button-35" @click="makeBabies()">MAKE BABIES!</button>
            </div>
        </b-modal>



        <b-modal size="xl" hide-footer title="FUSE DUCKS" ref="modal-2">
            <div v-if="!isApprovedFusion">
                <button v-if="!loadingTransaction" class="button-35" @click="fusionApprove()">Approve Fusion!</button>
                <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
            </div>
            <br><br>
            <div v-if="isApprovedFusion">
                <h4 class="centerTxt" v-if="fusionById.length > 0">SELECT DUCKS FOR FUSION</h4>
                    <br><br>
                    <div v-for="(id) in fusionById" :key="id">
                        <a @click="addNftDuck(id)" v-if="id > 1000" class="cardClick"><b-card
                            :title="'Duck #' + id"
                            tag="duck"
                            class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs"
                            :id="'cosmic' + id"
                        >
                        <img  class="imageOfDuck" :src="cosmicDuck + id + '.png'" alt="">
                        </b-card></a>
                    </div>
                    <br><br><br><br><br><br><br><br><br><br>
                    <br><br><br><br><br><br><br><br><br><br>
                    <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                    <button v-if="selectedToFuse.length > 0 && !loadingTransaction" class="button-35"  @click="fuse()">FUSE DUCKS!</button>

            </div>
        </b-modal>

    <div v-if="isMobile()">
        <img class="rewardsMobile" src="../assets/mobile/fuseBreed.png" alt="" usemap="#image-mapMobile">
        <map name="image-mapMobile">
            <area @click="openFuseModal()" target="" alt="fusion" title="fusion" coords="243,369,843,566" shape="rect">
            <area @click="openBabyModal()" target="" alt="genesis" title="genesis" coords="244,592,846,769" shape="rect">    
        </map>
    </div>


    <Footer/>
</div>
</template>

<script>
import NavBar from './Navigation/NavBar.vue'
import Web3 from 'web3';
import Footer from './Navigation/Footer.vue'
import clabs from '../assets/contracts/clabs.json'
import babyContractInfo from '../assets/contracts/babies.json'
import cut from '../assets/contracts/newCut.json'
import fusionContractInfo from '../assets/contracts/fusion.json'
export default {
    components:{
        NavBar,
        Footer
    },
    mounted()
    {
        $(document).ready(function(e) {
            $('img[usemap]').rwdImageMaps();
        });
        this.LoadEthWallet();
    },
    created() {
    window.location.href = "https://chimbastudios.com/cosmic-labs"; // Replace with your desired URL
  },
    data: function () {
            return {
                web3: '',

                walletAddress: '',
                walletBalance: '',

                cosmiclabsContract: '',
                contractAbi: clabs.abi,
                contractAddress: clabs.contractAddress,

                tokenContract: '',
                tokenContractAbi: cut.abi,
                tokenContractAddress: cut.contractAddress,

                tokenAmount: '',

                babyContract: '',
                babyContractAbi: babyContractInfo.abi,
                babyContractAddress: babyContractInfo.contractAddress,

                fusionContract: '',
                fusionContractAbi: fusionContractInfo.abi,
                fusionContractAddress: fusionContractInfo.contractAddress,


                isApproved: false,
                isApprovedFusion: false,
                loadingTransaction: false,

                nftsById: [],
                fusionById: [],
                selectedToBreed: [],
                selectedToFuse: [],


                genesisIpfs: 'https://cosmiclabs.mypinata.cloud/ipfs/QmctzpRxLg9Tk5nTgsczAy6W4reeN85n3BDohT27bEdRib/',
                cosmicDuck: 'https://cosmiclabs.mypinata.cloud/ipfs/QmVHZ3AgKQsz6m62jjuf56uHuaZYAShXW9rUMs8rP8pRrA/',
            }
    },
    methods:
    {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        openBabyModal()
        {
            if(this.nftsById.length > 0)
            {
                this.$refs['modal-1'].show();
            }
            else
            {
                alert("You don't have any Genesis to breed!");
            }
            
        },
        openFuseModal()
        {
            if(this.fusionById.length > 0)
            {
                this.$refs['modal-2'].show();
            }
            else
            {
                alert("You don't have any Cosmic Ducks to fuse!");
            }
            
        },
        fusionApprove()
        {
            this.loadingTransaction = true;
            this.cosmiclabsContract.methods.setApprovalForAll(this.fusionContractAddress, true ).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.loadingTransaction = false;
                this.LoadNFTs();
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        fuse()
        {
            this.loadingTransaction = true;
            
            if((this.selectedToFuse.length % 2) == 0)
            {
                this.fusionContract.methods.FuseDucks(this.selectedToFuse).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    alert("Congrats! You FUSED!");
                    this.loadingTransaction = false;
                    this.fusionById = [];
                    this.LoadNFTs();
                })
                .catch(err=>{
                    this.loadingTransaction = false;
                })
                .then(res=>{
                    this.loadingTransaction = false;
                })
            }
            else
            {
                this.loadingTransaction = false;
                alert("Select an even number of ducks!");
            }
            
        },
        addNftDuck(id)
        {
            var exists = false;
            var existingId;
            for(var i=0; i<this.selectedToFuse.length;i++)
            {
                if(this.selectedToFuse[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }
            if(!exists)
            {
                this.selectedToFuse.push(id);
                document.getElementById('cosmic' + id).style.background = "#0e99e8";
            }
            else
            {
                this.selectedToFuse.splice(existingId,1);
                document.getElementById('cosmic' + id).style.background = "none";
            }
        },
        addNft(id)
        {
            var exists = false;
            var existingId;
            for(var i=0; i<this.selectedToBreed.length;i++)
            {
                if(this.selectedToBreed[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }
            if(!exists)
            {
                if(this.selectedToBreed.length < 2)
                {
                    this.selectedToBreed.push(id);
                    document.getElementById('duck' + id).style.background = "#bc33ed";
                }
                else
                {
                    alert("You can only select 2!");
                }
                
            }
            else
            {
                this.selectedToBreed.splice(existingId,1);
                document.getElementById('duck' + id).style.background = "none";
            }
        },
        makeBabies()
        {
            this.loadingTransaction = true;

                if(this.tokenAmount >= (1300 * document.getElementById("howMany").value))
                {         
                    if(this.selectedToBreed.length == 2)
                    {
                        
                        this.babyContract.methods.createBabies(this.selectedToBreed, document.getElementById("howMany").value).send({from: this.walletAddress})
                        .on('confirmation', function(confirmationNumber, receipt)
                        {
                            
                        })
                        .then(res=>{
                            this.loadingTransaction = false;
                            this.selectedToBreed = [];
                            this.LoadNFTs();
                            if(document.getElementById("howMany").value > 1)
                            {
                                alert("Congrats You just made babies!");
                            }
                            else
                            {
                                alert("Congrats You just made a baby!");
                            }
                            
                        })
                        .catch(err=>{
                            this.loadingTransaction = false;
                            this.selectedToBreed = [];
                            this.LoadNFTs();
                        })
                    }
                    else
                    {
                        alert("Incorrect Amount! You must select only 2 Genesis Ducks!")
                        this.loadingTransaction = false;
                    }
                }
                else
                {
                    alert("You have " + this.tokenAmount + " and you need " + (1300 * document.getElementById("howMany").value) + " CUT");
                    this.loadingTransaction = false;
                }

            
        }, 
        babyApprove()
        {
            this.loadingTransaction = true;
            this.tokenContract.methods.approve(this.babyContractAddress, this.web3.utils.toWei('1000000000', 'ether') ).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.loadingTransaction = false;
                this.LoadNFTs();
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        LoadNFTs: function()
        {  
            
            this.cosmiclabsContract = new this.web3.eth.Contract(this.contractAbi, this.contractAddress);
        
            this.nftsById = [];
            this.fusionById = [];
            this.cosmiclabsContract.methods.walletOfOwner(this.walletAddress).call({from: this.walletAddress})
            .then(res=>{
                
                for(var i=0; i<res.length;i++)
                {
                    if(res[i] <= 1000)
                    {
                        this.nftsById.push(res[i]);   
                    }   
                    else
                    {
                        this.fusionById.push(res[i])
                    }
                }
                         
            })
            this.babyContract = new this.web3.eth.Contract(this.babyContractAbi, this.babyContractAddress);

            this.tokenContract = new this.web3.eth.Contract(this.tokenContractAbi, this.tokenContractAddress);
            this.tokenContract.methods.balanceOf(this.walletAddress).call({})
            .then(res=>{
                this.tokenAmount = this.web3.utils.fromWei(res, 'ether');
            })
            
            this.tokenContract.methods.allowance(this.walletAddress, this.babyContractAddress).call({})
            .then(res=>{
                
                if(Number(res) >= Number(this.web3.utils.toWei('1000000', 'ether')))
                {
                    this.isApproved = true;
                }
                else
                {
                    this.isApproved = false;
                }
            })

            this.cosmiclabsContract.methods.isApprovedForAll(this.walletAddress, this.fusionContractAddress).call({from: this.walletAddress})
            .then(res=>{
                this.isApprovedFusion = res;
            })
            this.fusionContract = new this.web3.eth.Contract(this.fusionContractAbi, this.fusionContractAddress);
            
          
        },
        LoadEthWallet: function(){
            
            if (typeof window.ethereum !== 'undefined') 
                {
                    ethereum.enable();
                    this.web3 = new Web3(this.walletConnect || window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
                    this.web3.eth.net.getNetworkType()
                    .then(network=>{
                        if(network == "main")
                        {
                            this.web3.eth.requestAccounts()
                            .then(acc=>{
                                this.walletAddress = acc[0];
                                this.web3.eth.getBalance(this.walletAddress)
                                .then(balance=>{
                                    this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                                    this.LoadNFTs();
                                });
                            })
                            .catch(err=>{
                                console.log(err);
                            })            
                        }
                        else{
                            this.chainChange();
                        }          
                    })
                }
            
        },   
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
                    this.LoadEthWallet();
        },    
    },
    
    watch: {
          walletAddress: function(val) {
            window.ethereum.on("accountsChanged", accounts => {
              if (accounts.length > 0)
              {
                this.walletAddress = accounts[0];
                this.web3.eth.getBalance(this.walletAddress)
                .then(balance=>{
                  this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                });
                this.LoadNFTs();
              } 
              else 
              {
                this.walletAddress = '';
                this.walletBalance = '';
              }
            })
          },
          walletBalance: function(val)
          {
            window.ethereum.on("balanceChanged", balance => 
            {
              this.walletBalance = balance;
              this.LoadNFTs();
            })
            
          },
    },
}
</script>

<style scoped>
.rewardsMobile
{
    width: 100%;
}
.notAvail
{
    margin-top: 20vh;
    color: white;
    font-size: 3vh;
}
.breedfuse
{
    width: 100%;
}
.areaClick
{
    cursor: pointer;
}

.button-35 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
}

.imageOfDuck
{
    width: 100%;
    margin-top:auto
}
.card-title {
    margin-bottom: 0.5rem;
    font-size: 2vh;
}
.clabs
{
    width: 20vh;
    float: left;
    margin-left: 2vh;
    display: flex !important;
    margin-bottom: 2vh;
}
.cardClick
{
    text-decoration: none;
    color: black;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/FuseBreed.vue